module.exports = __webpack_public_path__ + "static/media/novair.230b8bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/novair.svg
// module id = 105
// module chunks = 3